import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import {
  Engine,
  Scene,
  Mesh,
  Color3,
  Color4,
  Vector3,
  StandardMaterial,
  Texture,
  ExecuteCodeAction,
  ActionManager,
  MeshBuilder,
  Plane,
  ArcRotateCamera,
  Animation,
  UniversalCamera,
  FreeCamera,
  FreeCameraTouchInput,
  AssetsManager,
  DeviceOrientationCamera,
} from "babylonjs";
import "babylonjs-materials";
import { promises, resolve } from "dns";
import { Subject } from "rxjs";
import { runInThisContext } from "vm";
import { ImageService } from "./image.service";

declare let gtag: Function;

@Injectable({ providedIn: "root" })
export class WalkthroughService {
  private engine;
  private camera: any;
  private environmet: Mesh;
  private currentConfig;
  //private textureEnvironments: any[] = [];
  public configuration;

  private openModalSource = new Subject<void>();
  public openModal = this.openModalSource.asObservable();

  private textureLoadingSource = new Subject<boolean>();
  public textureLoading = this.textureLoadingSource.asObservable();

  private targetMaterial;
  private productMaterial;
  // private images = new Map();
  private downloading = false;

  private linksLoaded = [];

  public ready = new EventEmitter();

  public constructor(private imageService: ImageService) {}

  public async createScene(
    canvas: HTMLCanvasElement,
    engine: Engine,
    id: any,
    data: any
    //: Scene {
  ) {
    this.engine = engine;
    this.configuration = data;
    // create a basic BJS Scene object
    const scene = new Scene(engine);
    scene.clearColor = new Color4(0, 0, 0, 0);

    if (data.camera_type && data.camera_type === "device_orientation") {
      this.camera = new DeviceOrientationCamera(
        "camera",
        new Vector3(0, 0, 0),
        scene
      );
    } else {
      this.camera = new FreeCamera("camera", new Vector3(0, 0, 0), scene);
    }

    this.camera.inputs.remove(this.camera.inputs.attached.keyboard);

    Object.defineProperty(this.camera, "_setTarget", {
      set: function (v) {
        this.setTarget(v);
      },
    });

    // target the camera to scene origin
    //this.camera.setTarget(Vector3.Zero());

    //this.camera.rotation.y = -1.57;
    this.camera.fov = 1;
    // attach the camera to the canvas
    this.camera.attachControl(canvas, false);

    this.camera.invertRotation = true;

    this.camera.angularSensibility = this.configuration.angularSensibility;

    // turn on debugLayer
   // scene.debugLayer.show();

    scene["client"] = this.configuration.client;

    scene.registerBeforeRender(() => {
      //Limita el movimiento de la cámara
      if (this.currentConfig && this.currentConfig.movement) {
        if (this.camera.rotation.x > 0.5) {
          this.camera.rotation.x = 0.5;
        }
        if (this.camera.rotation.x < -0.5) {
          this.camera.rotation.x = -0.5;
        }
        if (this.camera.rotation.y > 1) {
          this.camera.rotation.y = 1;
        }
        if (this.camera.rotation.y < -1) {
          this.camera.rotation.y = -1;
        }
      }
    });

    // create environment
    this.createEnvironments(scene, id);
    // .then((env) => {
    //   this.environmet = env;
    // });
    // return scene;
  }

  /**
   *
   * @param scene
   */
  private createEnvironments(scene, id) {
    // create environmete sphere
    const environmentSphere = MeshBuilder.CreateSphere(
      "environment",
      { diameter: 10, segments: 64 },
      scene
    );
    //Roto la esfera
    environmentSphere.rotation.y = 1.57;

    // optimitation
    environmentSphere.freezeWorldMatrix();

    // create material
    const material = new StandardMaterial("environmentMaterial", scene);
    material.backFaceCulling = false;
    material.disableLighting = true;
    // assign material to environment sphere
    environmentSphere.material = material;
    // optimitation
    environmentSphere.material.freeze();

    //get current scene
    if (id) {
      this.currentConfig = this.configuration.environments.filter(
        (env) => env.id === id
      )[0];
    } else {
      this.currentConfig = this.configuration.environments.filter(
        (env) => env.default
      )[0];
    }

    // create product button texture
    const productTexture = new Texture(
      "./assets/images/icons/button.png",
      scene
    );
    this.productMaterial = new StandardMaterial("productLinkMaterial", scene);
    this.productMaterial.backFaceCulling = false;
    this.productMaterial.disableLighting = true;
    this.productMaterial.diffuseTexture = productTexture;
    this.productMaterial.diffuseTexture.hasAlpha = true;
    this.productMaterial.useAlphaFromDiffuseTexture = true;
    if (this.configuration && this.configuration.client && this.configuration.client.logo_color){
        this.productMaterial.emissiveColor = BABYLON.Color3.FromHexString(this.configuration.client.logo_color); //new BABYLON.Color3(this.configuration.client.logo_color.r, this.configuration.client.logo_color.g, this.configuration.client.logo_color.b)
    }else{
        this.productMaterial.emissiveTexture = productTexture;
    }
    // optimitation
    this.productMaterial.freeze();

    // create targetMaterial
    const targetTexture = new Texture(
      this.configuration.movement_type === "arrow"
        ? "./assets/images/movement/arrow.png"
        : "./assets/images/icons/pin.png",
      scene
    );
    this.targetMaterial = new StandardMaterial("linkMaterial", scene);
    this.targetMaterial.backFaceCulling = false;
    this.targetMaterial.disableLighting = true;
   // this.targetMaterial.emissiveTexture = targetTexture;
    this.targetMaterial.diffuseTexture = targetTexture;
    this.targetMaterial.diffuseTexture.hasAlpha = true;
    this.targetMaterial.useAlphaFromDiffuseTexture = true;
    if (this.configuration && this.configuration.client && this.configuration.client.logo_color){
      this.targetMaterial.emissiveColor = BABYLON.Color3.FromHexString(this.configuration.client.logo_color); //(this.configuration.client.logo_color.r, this.configuration.client.logo_color.g, this.configuration.client.logo_color.b)
    }else{
        this.targetMaterial.emissiveTexture = targetTexture;
    }
    
    // optimitation
    this.targetMaterial.freeze();

    //Armo la lista de los próximos ambientes a cargar más el actual
    let currentAndNextEnvs = [this.currentConfig.id];
    this.currentConfig.links
      .map((e) => e.targetId)
      .forEach((element) => currentAndNextEnvs.push(element));

    //Descargo todas las imágenes pero con prioridad las actuales
    this.imageService.downloadImages(
      this.configuration,
      this.engine.getCaps().maxTextureSize,
      currentAndNextEnvs
    );

    // Cuando la descarga terminó
    this.imageService.imageLoaded.subscribe((id) => {
      //Si es la de la escena actual, se descargó la de las proximas
      if (id === this.currentConfig.id) {
        // assing emissive texture
        material.emissiveTexture = this.createTexture(
          scene,
          this.imageService.images.get(this.currentConfig.id)
        );
        // create link buttons
        this.createLinks(this.currentConfig.links, environmentSphere, scene);
        // create product buttons
        this.createProductLinks(
          this.currentConfig.objects,
          environmentSphere,
          scene
        );
        this.environmet = environmentSphere;
        this.ready.emit(scene);
      } else {
        this.createLinks(this.currentConfig.links, environmentSphere, scene);
      }
    });
  }

  createTexture(scene, image) {
    let texture;
    if (!image.get("error")) {
      texture = Texture.LoadFromDataString(
        "image" + Math.random(),
        image.get("file"),
        scene
      );
    } else {
      texture = new Texture(image.get("url"), scene);
    }
    texture.uScale = 1;
    texture.vScale = 1;
    texture.uAng = Math.PI;
    return texture;
  }

  createTextureWithCallback(scene, image, animations, nextEnvironment, target) {
    let texture;
    this.textureLoadingSource.next(true);
    if (!image.get("error")) {
      texture = Texture.LoadFromDataString(
        "image" + Math.random(),
        image.get("file"),
        scene,
        false,
        false,
        true,
        Texture.TRILINEAR_SAMPLINGMODE,
        () => {
          //Arrancar animación
          texture.uScale = 1;
          texture.vScale = 1;
          texture.uAng = Math.PI;
          this.textureLoadingSource.next(false);
          this.startAnimation(
            animations,
            scene,
            nextEnvironment,
            target,
            texture
          );
        }
      );
    } else {
      texture = new Texture(
        image.get("url"),
        scene,
        false,
        true,
        Texture.TRILINEAR_SAMPLINGMODE,
        () => {
          //Arrancar animación
          texture.uScale = 1;
          texture.vScale = 1;
          texture.uAng = Math.PI;
          this.textureLoadingSource.next(false);
          this.startAnimation(
            animations,
            scene,
            nextEnvironment,
            target,
            texture
          );
        }
      );
    }
    // return texture;
  }

  createProductLinks(objects, environmentSphere, scene) {
    if (objects) {
      for (let i = 0; i < objects.length; i++) {
        const linkObject = this.createLinkObject(
          scene,
          objects[i].rotation,
          objects[i].size,
          environmentSphere,
          this.productMaterial
        );
        // define link actions
        this.setProductLinksActions(linkObject[0], objects[i], scene);
      }
    }
  }

  private setProductLinksActions(linkObject, target, scene) {
    linkObject.actionManager = new ActionManager(scene);
    //En Click/Touch va a la nueva escena
    linkObject.actionManager.registerAction(
      new ExecuteCodeAction(ActionManager.OnPickTrigger, () => {
        // previousAutoRotateValue = autoRotate;
        // autoRotate = false;
        gtag("event", `${this.configuration.client.name}_open_modal`, {
          target: target.name,
        });
        this.openModalSource.next(target);
      })
    );

    // //Cuando se saca el hover, se prende el autorotate y se oculta el name
    // doorObject.actionManager.registerAction(new ExecuteCodeAction(ActionManager.OnPointerOutTrigger, function(){
    // 	autoRotate = true;
    // 	label.fadeOut(100);
    // }));
    // //En el hover, se prende el autorotate y se oculta el name
    // doorObject.actionManager.registerAction(new ExecuteCodeAction(ActionManager.OnPointerOverTrigger, function(){
    // 	autoRotate = false;
    // 	if(doorObject.name) {
    // 		var sceneId = getSceneIdFromName(doorObject.name);
    // 		label.text(scenes[sceneId].name).fadeIn(100);
    // 	}
    // }));
  }

  /**
   *
   * @param links
   * @param environmentSphere
   * @param scene
   */
  private createLinks(links, environmentSphere, scene) {
    for (const link of links) {
      if (!this.linksLoaded.includes(link.targetId)) {
        const image = this.imageService.images.get(link.targetId);
        if (image && !image.get("error")) {
          this.linksLoaded.push(link.targetId);
          this.createLink(scene, link, environmentSphere);
        }
      }
    }
  }

  private createLink(scene: any, target, environmentSphere: any) {
    const linkObjects = this.createLinkObject(
      scene,
      target.rotation,
      target.size,
      environmentSphere,
      this.targetMaterial
    );
    // define link actions
    this.setLinksActions(linkObjects, target, scene);
  }

  private createLinkObject(scene, rotation, size, environmentSphere, material) {
    const linkObject = MeshBuilder.CreatePlane(
      "link",
      {
        height: size.icon,
        width: size.icon,
        sideOrientation: Mesh.DOUBLESIDE,
      },
      scene
    );

    //linkObject.parent = environmentSphere;

    linkObject.position.z = 4.5;
    linkObject.setPivotPoint(new Vector3(0, 0, -4.5));

    rotation.icon = rotation.icon.replace(/\s/g, "");
    const xyz = rotation.icon.split(",");
    linkObject.rotation = new Vector3(xyz[0], xyz[1], xyz[2]);
    linkObject.material = material;
    //linkObject.lookAt(Vector3.Zero());
    linkObject.scaling = new Vector3(1, 1, 1);

    let linkObject2;
    if (rotation.target) {
      // Temporal para ver los íconos del target
      const targetTexture = new Texture(
        "./assets/images/icons/target.png",
        scene
      );
      const doorMaterial = new StandardMaterial("linkMaterial", scene);
      doorMaterial.emissiveColor = new Color3(1, 0, 0);
      doorMaterial.opacityTexture = targetTexture;
      doorMaterial.diffuseTexture = targetTexture;
      linkObject2 = MeshBuilder.CreatePlane(
        "link",
        {
          //0.6
          height: size.target,
          width: size.target,
          sideOrientation: Mesh.DOUBLESIDE,
        },
        scene
      );
      linkObject2.position.z = 4.5;
      linkObject2.setPivotPoint(new Vector3(0, 0, -4.5));
      rotation.target = rotation.target.replace(/\s/g, "");
      const targetXYZz = rotation.target.split(",");
      linkObject2.rotation = new Vector3(
        targetXYZz[0],
        targetXYZz[1],
        targetXYZz[2]
      );
      linkObject2.scaling = new Vector3(1, 1, 1);
      linkObject2.material = doorMaterial;
      linkObject2.visibility = this.configuration.target_visible;
      //linkObject2.lookAt(Vector3.Zero());
    }

    return [linkObject, linkObject2];
  }

  /**
   *
   * @param linkObject Plane
   * @param target config.env.link
   * @param scene
   */
  private setLinksActions(linkObjects, target, scene) {
    linkObjects[0].actionManager = new ActionManager(scene);
    //En Click/Touch va a la nueva escena
    linkObjects[0].actionManager.registerAction(
      new ExecuteCodeAction(ActionManager.OnPickTrigger, () => {
        // previousAutoRotateValue = autoRotate;
        // autoRotate = false;

        // delete old links
        const links = scene.meshes.filter((each) => each.name === "link");
        const linksSize = links.length;
        let linkDisposed = 0;
        links.forEach((element) => {
          element.onDisposeObservable.add(() => {
            linkDisposed++;
            if (linkDisposed === linksSize) {
              setTimeout(() => {
                this.goToThisTarget(linkObjects[1], target, scene);
              }, 50);
            }
          });
          element.setEnabled(false);
          element.dispose();
        });
      })
    );
    // //Cuando se saca el hover, se prende el autorotate y se oculta el name
    // doorObject.actionManager.registerAction(new ExecuteCodeAction(ActionManager.OnPointerOutTrigger, function(){
    // 	autoRotate = true;
    // 	label.fadeOut(100);
    // }));
    // //En el hover, se prende el autorotate y se oculta el name
    // doorObject.actionManager.registerAction(new ExecuteCodeAction(ActionManager.OnPointerOverTrigger, function(){
    // 	autoRotate = false;
    // 	if(doorObject.name) {
    // 		var sceneId = getSceneIdFromName(doorObject.name);
    // 		label.text(scenes[sceneId].name).fadeIn(100);
    // 	}
    // }));
  }

  /**
   *
   * @param target
   * @param scene
   */
  private goToThisTarget(linkObject, target, scene: Scene) {
    // find next env
    const nextEnvironment = this.configuration.environments.filter(
      (each) => each.id === target.targetId
    )[0];

    // Google Analytics Download CSV tracking

    gtag("event", `${this.configuration.client.name}_movement`, {
      environment: nextEnvironment.id,
    });

    const animations = this.createAnimations(linkObject.getAbsolutePosition());
    const image = this.imageService.images.get(target.targetId);
    this.createTextureWithCallback(
      scene,
      image,
      animations,
      nextEnvironment,
      target
    );
    // execute animations
    // scene.beginDirectAnimation(this.camera, animations, 0, 50, false, 1, () =>
    //   this.afterAnimationsEnd(nextEnvironment, target, scene, newTexure)
    // );
  }

  private startAnimation(
    animations,
    scene,
    nextEnvironment,
    target,
    newTexture
  ) {
    scene.beginDirectAnimation(this.camera, animations, 0, 50, false, 1, () => {
      this.afterAnimationsEnd(nextEnvironment, target, scene, newTexture);
    });
  }

  private afterAnimationsEnd(
    nextEnvironment: any,
    target: any,
    scene: Scene,
    newTexure
  ) {
    this.currentConfig = nextEnvironment;
    this.linksLoaded = [];
    // reset camera properties
    this.camera.fov = 1;

    //current texture to delete
    const texture = (this.environmet.material as StandardMaterial)
      .emissiveTexture;

    // assing new texture
    (this.environmet.material as StandardMaterial).emissiveTexture = newTexure;

    scene.textures.filter((currText) => currText === texture)[0].dispose();
    texture.dispose();

    this.createLinks(this.currentConfig.links, this.environmet, scene);

    if (nextEnvironment.objects) {
      this.createProductLinks(nextEnvironment.objects, this.environmet, scene);
    }
  }

  private cleanTextures(scene: Scene, texturesToNoDispose: any[]) {
    scene.textures.forEach((element) => {
      const url = element["url"];
      const targetId = element["target"];
      if (
        !url.includes("locationPin_web") &&
        !url.includes("productButton_web") &&
        !texturesToNoDispose.includes(targetId)
      ) {
        element.dispose();
      }
    });
  }

  private createAnimations(position): any[] {
    const animations = [];
    // rotation = rotation.replace(/\s/g, "");
    // const xyz = rotation.split(",");
    // animation to look target
    animations.push(
      this.createAnimation(
        "animationName",
        "_setTarget",
        50,
        Animation.ANIMATIONTYPE_VECTOR3,
        this.camera.getTarget(),
        position
        //new Vector3(xyz[0], xyz[1], xyz[2])
      )
    );

    // animation to "move" to target
    animations.push(
      this.createAnimation(
        "animationName",
        "fov",
        50,
        Animation.ANIMATIONTYPE_FLOAT,
        this.camera.fov,
        this.camera.fov - 0.5
      )
    );

    return animations;
  }

  /**
   * @param nameAnimation
   * @param propertyName
   * @param fps
   * @param animationType
   * @param from
   * @param to
   */
  private createAnimation(
    nameAnimation: string,
    propertyName: string,
    fps: number,
    animationType: any,
    from,
    to
  ) {
    const animation = new Animation(
      nameAnimation,
      propertyName,
      fps,
      animationType,
      Animation.ANIMATIONLOOPMODE_CONSTANT
    );

    const keys = [
      {
        frame: 0,
        value: from,
      },
      {
        frame: 100,
        value: to,
      },
    ];

    animation.setKeys(keys);
    return animation;
  }

  public toogleLinks(hide: boolean, scene) {
    scene.meshes
      .filter((each) => each.name === "link")
      .forEach((each) => each.setEnabled(hide));
  }
}
